<div>
  <mat-form-field appearance="fill">
    <mat-label>Selecteer een datum</mat-label>
    <input matInput [matDatepicker]="tourDatePicker" [formControl]="date" />
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle
      matSuffix
      [for]="tourDatePicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #tourDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Selecteer een installateur</mat-label>
    <mat-select [(value)]="selected">
      <mat-option *ngFor="let option of options" [value]="option.value">
        {{ option.viewValue }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="example-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="selected">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="jobno">
        <th mat-header-cell *matHeaderCellDef>Jobnr</th>
        <td mat-cell *matCellDef="let element" [class]="element.class">
          {{ element.jobno }}
        </td>
      </ng-container>

      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef>Klant</th>
        <td mat-cell *matCellDef="let element" [class]="element.class">
          {{ element.client }}
        </td>
      </ng-container>

      <ng-container matColumnDef="requestedDate">
        <th mat-header-cell *matHeaderCellDef>Aanvraagdatum</th>
        <td mat-cell *matCellDef="let element" [class]="element.class">
          {{ element.requestedDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Afm+type</th>
        <td mat-cell *matCellDef="let element" [class]="element.class">
          {{ element.type }}
        </td>
      </ng-container>

      <ng-container matColumnDef="requestedPlacementDate">
        <th mat-header-cell *matHeaderCellDef>Gewenste plaatsingsdatum</th>
        <td mat-cell *matCellDef="let element" [class]="element.class">
          {{ element.requestedPlacementDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="photo">
        <th mat-header-cell *matHeaderCellDef>Foto</th>
        <td mat-cell *matCellDef="let element" [class]="element.class">
          {{ element.photo }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
